// SelectDropdown.js
import React from 'react';

const Option = ({value, children,disabled,selected,className}) => {
  return (
    <option
      value={value}
      disabled={disabled}
      selected={selected}
      className={className}
    >
      {children}
    </option>
  );
};

export default Option;
